<script>
import CandelaComponent from '@/components/CandelaComponent'

export default {
  computed: {
    all_cells() {
      if(!this.data) return 0
      return this.data.flatMap(x => x)
    },
    template_columns_str() {
      if(!this.data) return 'auto'
      return [...Array(this.data[0].length)].map((x, i) => 'auto').join(' ')
    }
  },
  extends: CandelaComponent,
  name: 'candela-cell-grid',
  props: {
    data: {type: Array, default: () => []}
  }
}
</script>

<template>
<div class='candela-component'>
  <div class='cell-grid-container'>
    <div class='cell-grid'
      :style='{gridTemplateColumns: template_columns_str}'>
      <div v-for='(cell, i) in all_cells'
        :key='i' class='cell-grid-item'
        :style='{backgroundColor: settings.colors.value(cell)}'/>
    </div>
  </div>
</div>
</template>
<style lang='sass' scoped>
.cell-grid-container
  display: flex
  min-width: 100%

.cell-grid
  width: 100%
  height: 100%
  display: grid
  grid-column-gap: 2px
  grid-row-gap: 2px
  grid-template-columns: auto auto auto

  .cell-grid-item
    width: 100%
    height: 100%
    background-color: lightseagreen
    border-radius: 0.1em
    transition: background-color 0.1s
</style>
